export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/DatabaseWorker.097bcc9a.worker.js");
}
